/**
 * 日付ユーティリティ関数
 * ローカルタイムゾーンで日付を処理する
 */

/**
 * Date オブジェクトを YYYY-MM-DD 形式の文字列にフォーマット（ローカルタイムゾーン）
 * toISOString() は UTC に変換するため使用しない
 */
export function formatDateLocal(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * YYYY-MM-DD 形式の文字列を Date オブジェクトにパース（ローカルタイムゾーン）
 * new Date(string) は UTC として解釈されるため使用しない
 */
export function parseDateLocal(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number)
  return new Date(year, month - 1, day)
}

/**
 * 開始日から終了日までの Date 配列を生成（ローカルタイムゾーン）
 */
export function getDaysInRange(startDate: string, endDate: string): Date[] {
  const days: Date[] = []
  const start = parseDateLocal(startDate)
  const end = parseDateLocal(endDate)

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    days.push(new Date(d))
  }

  return days
}
